import image1 from './images/image1.webp';
import image2 from './images/image2.webp';
import image3 from './images/image3.webp';

const post = {
  id: 2,  // Remember to update this for each new post
  slug: "ai-for-youth",
  title: "AI For Youth",
  date: "25 May, 2025",
  preview: "Some lessons from teaching.",
  content: `

### Overview
I recently completed my 26 hours with students from Catholic Junior College (CJC). I taught them
Intel's AI For Youth course, covering most of the AI basics: Python, NumPy, Pandas, Fine-Tuning, GANs, diffusion models and so on.

I wanted to write a blog post today to reflect and talk about some of the things I learned from this. It was a heartwarming journey that I hope
you (the reader) might gain some insights from!

### Challenges and Solutions
Throughout the course we would use Google Colab notebooks to run through most of the concepts. I'd usually start on
the whiteboard and slides and then show an example of an implementation in code. It was really heartening to see the students
light up when they could see *something* happening.

![GAN-model](${image2})
*A GAN model being trained to recognise numbers*

At first I had tried to stick to the provided course tools. One software that students were required to use was called 'Orange Data Mining'.
The issue was that some students had chromebooks or iPads, so they couldn't download it. I eventually did almost everything on Google Colab. 
I suppose the lesson here is that Google Colab saves lives — it's like Docker for teaching (I hope that made sense).

Another issue was attention. Frankly, it was hard to always keep the students listening. They would wander off into their own world on their laptops
or start talking to their friends. My clever solution was that I would bring a rubber duck!
![rubber-duck](${image3})
*My rubber duck (left) next to my friend's not-so-rubber duck (right)*

I think I bought this thing for $1.50 from Shoppee. I remember being really inspired by the concept of rubber duck debugging
— so much so that I had to purchase my own rubber duck. The wonderful thing about this duck is that when you squeezed it, it would
make this extremely, obnoxious, loud squeaky sound. Therefore, when I needed the student's attention, I would simply give my duck a squeeze.
It was almost pavlovian how they gradually started to become accustomed to the duck's cry as the signal for lesson to commence. I was proud of myself
for this idea because my voice was beginning to become very hoarse.

I tried my best to be a really understanding teacher. Some students weren't really interested in the lesson so I tried
to be accommodating and allowed them to pursue whatever they found to be interesting — as long as it was productive.
I recall approaching one student and asking him how everything was coming along. He told me he wasn't really interested in the lesson.
I went "Okay, what would you like to do instead?" He told me he wanted to read about Gravastars. He then showed his screen which displayed a paper titled *Gravastar models in
the structure of f(R, Lm, T) modified theory of gravity*.

I recall feeling very surprised seeing him reading about that.
I think being in SMU for so long has actually caused me to forget that sciences such as physics or biology existed.
He then continued by saying his father was a physicist and that he want to follow in his footsteps. Clearly, there was no way
that I could say no to that. So I told him that it's completely fine to continue reading but on the condition that we talk about the paper next week.

At the end of the course they were required to do a project. 

![student-project](${image1})
*One of my students utilising OpenCV to make an attendance tracking system*

I tried my best to help them through the various aspects of the project. While I taught them the basics of Python, most of their desired projects
went beyond that scope. We unfortunately had to resort to LLMs to get something out. I'm glad to say that most of them 
managed to come up with something at the end and submitted!

### Reflections

I've always loved teaching. I'd attribute a lot of my success today to some of the great teachers I've had before.
I still remember failing Mathematics when I was in secondary 2. Then I met a new teacher in secondary 3: Mr Chen. He was 
such a brilliant guy. You could tell he enjoyed what he was teaching and he had a deep passion for it. Perhaps that
passion somehow diffused into me too because I started to really love the study of Mathematics. Especially pure Mathematics
— where we would ponder for hours on end about how to prove a triangle was similar to another and then when you got it
you'd just jump up and start scribbling down the proof.

I'm not sure if I was ever able to convey that same energy and that same passion to my students in CJC. I definitely tried my best
to do so, even making my lessons holisitic sometimes. I remember we had one session where I would tell the students about whatever they wanted to know.
We used Mentimeter and had a word cloud. The students would submit the topics they wanted me to talk about and I would address them from there.
A couple of them asked me how to excel in GP (General Paper) so I gave them some tips. Some of them were curious about programming in general so
I shared about what were programming skills and languages were most in-demand within the industry. I also gave them some love life advice haha.

I would say on a whole, I'm very glad that I was given this chance to teach. My students were all very very sweet and I hope I've made some kind of
last impact on them :)
`
};

export default post;
